// extracted by mini-css-extract-plugin
module.exports = {"icon":"DownloadReport_icon__wurrZ"};